import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Complete ResizeObserver error suppression
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = self;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const _ = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    callback = debounce(callback, 20);
    super(callback);
  }
};

// Suppress error display
window.addEventListener('error', (e) => {
  if (
    e.message.includes('ResizeObserver') ||
    e.message.includes('removeChild')
  ) {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Override console.error
const originalError = console.error;
console.error = function filterWarnings(...args) {
  const firstArg = args[0];
  if (
    typeof firstArg === 'string' &&
    (firstArg.includes('ResizeObserver') || firstArg.includes('removeChild'))
  ) {
    return;
  }
  originalError.apply(console, args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
